import {getSQLFiles,executeSQLScripts} from './file'

export const dataService = {  
    getSQLFiles,
    executeSQLScripts
};